import { render, staticRenderFns } from "./LineChartPHB2BB2C.vue?vue&type=template&id=8c1a277a&scoped=true&lang=pug&"
import script from "./LineChartPHB2BB2C.vue?vue&type=script&lang=ts&"
export * from "./LineChartPHB2BB2C.vue?vue&type=script&lang=ts&"
import style0 from "./LineChartPHB2BB2C.vue?vue&type=style&index=0&id=8c1a277a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1a277a",
  null
  
)

export default component.exports